module.exports = __webpack_public_path__ + "static/21-08-26_12-20-47_7540-f965fbf4d55b4ae7f1f60af8cb1afdc4.png";